'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeCreatableSelect = exports.defaultProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _utils = require('./utils');

var _stateManager = require('./stateManager');

var _stateManager2 = _interopRequireDefault(_stateManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const compareOption = (inputValue, option) => {
  const candidate = inputValue.toLowerCase();
  return option.value.toLowerCase() === candidate || option.label.toLowerCase() === candidate;
};

const builtins = {
  formatCreateLabel: inputValue => `Create "${inputValue}"`,
  isValidNewOption: (inputValue, selectValue, selectOptions) => !(!inputValue || selectValue.some(option => compareOption(inputValue, option)) || selectOptions.some(option => compareOption(inputValue, option))),
  getNewOptionData: (inputValue, optionLabel) => ({
    label: optionLabel,
    value: inputValue,
    __isNew__: true
  })
};

const defaultProps = exports.defaultProps = _extends({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);

const makeCreatableSelect = SelectComponent => {
  var _class, _temp;

  return _temp = _class = class Creatable extends _react.Component {
    constructor(props) {
      super(props);

      this.onChange = (newValue, actionMeta) => {
        const {
          getNewOptionData,
          inputValue,
          isMulti,
          onChange,
          onCreateOption,
          value
        } = this.props;
        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }
        const { newOption } = this.state;
        const valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            const newOptionData = getNewOptionData(inputValue, inputValue);
            const newActionMeta = { action: 'create-option' };
            if (isMulti) {
              onChange([...(0, _utils.cleanValue)(value), newOptionData], newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }
        onChange(newValue, actionMeta);
      };

      const options = props.options || [];
      this.state = {
        newOption: undefined,
        options: options
      };
    }
    componentWillReceiveProps(nextProps) {
      const {
        allowCreateWhileLoading,
        createOptionPosition,
        formatCreateLabel,
        getNewOptionData,
        inputValue,
        isLoading,
        isValidNewOption,
        value
      } = nextProps;
      const options = nextProps.options || [];
      let { newOption } = this.state;
      if (isValidNewOption(inputValue, (0, _utils.cleanValue)(value), options)) {
        newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
      } else {
        newOption = undefined;
      }
      this.setState({
        newOption: newOption,
        options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption, ...options] : [...options, newOption] : options
      });
    }

    focus() {
      this.select.focus();
    }
    blur() {
      this.select.blur();
    }
    render() {
      const props = _objectWithoutProperties(this.props, []);
      const { options } = this.state;
      return _react2.default.createElement(SelectComponent, _extends({}, props, {
        ref: ref => {
          this.select = ref;
        },
        options: options,
        onChange: this.onChange
      }));
    }
  }, _class.defaultProps = defaultProps, _temp;
};

// TODO: do this in package entrypoint
exports.makeCreatableSelect = makeCreatableSelect;
exports.default = (0, _stateManager2.default)(makeCreatableSelect(_Select2.default));